module.exports = __webpack_public_path__ + "static/img/course5.a017a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course5.png
// module id = dXih
// module chunks = 63